"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentVisibility = void 0;
const useAppContext_1 = require("./useAppContext");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useComponentVisibility = (componentName) => {
    const context = useAppContext_1.useAppContext();
    const isVisible = context.isVisible(componentName);
    const setVisible = () => {
        context.setIsVisible(componentName, true);
    };
    const setHidden = () => {
        context.setIsVisible(componentName, false);
    };
    const setIsVisible = (value) => {
        context.setIsVisible(componentName, value);
    };
    return { isVisible, setVisible, setHidden, setIsVisible };
};
exports.useComponentVisibility = useComponentVisibility;
//# sourceMappingURL=useComponentVisibility.js.map